import { NavLink } from "react-router-dom";
import { Icon, type IconName } from "./Icon";
import { plural } from "@/lib/format";
import { cx } from "@/lib/cx";

export interface TabItem {
  to: string;
  label: string;
  icon: IconName;
  badge?: number;
}

export function BottomTabs({ items }: { items: TabItem[] }) {
  return (
    <nav className="tabs" aria-label="Navegação principal">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => cx("tab", isActive && "active")}
          end={item.to === "/conversas"}
        >
          {({ isActive }) => (
            <>
              <span className="tab-icon" aria-hidden="true">
                <Icon name={item.icon} size={20} className="mx-auto" />
              </span>
              {item.label}
              {item.badge && item.badge > 0 ? (
                <span className="tab-badge" aria-hidden="true">
                  {item.badge > 99 ? "99+" : item.badge}
                </span>
              ) : null}
              {item.badge && item.badge > 0 ? (
                <span className="sr-only">{plural(item.badge, "não lida", "não lidas")}</span>
              ) : null}
              {isActive ? <span className="sr-only">(aba atual)</span> : null}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}

/** Navegacao lateral no layout expandido (&gt;=900px). */
export function SidebarNav({ items }: { items: TabItem[] }) {
  return (
    <nav className="flex w-[76px] shrink-0 flex-col gap-2 border-r border-line bg-surface py-3" aria-label="Navegação principal">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === "/conversas"}
          className={({ isActive }) =>
            cx(
              "relative mx-2 flex min-h-[56px] flex-col items-center justify-center gap-1 rounded-md text-[10px] font-semibold text-fg-secondary",
              isActive && "bg-brand-soft text-[color:var(--tg-primary-text)]",
            )
          }
        >
          <Icon name={item.icon} size={20} />
          <span>{item.label}</span>
          {item.badge && item.badge > 0 ? (
            <span className="badge-count" aria-hidden="true">
              {item.badge > 99 ? "99+" : item.badge}
            </span>
          ) : null}
          {item.badge && item.badge > 0 ? <span className="sr-only">{plural(item.badge, "não lida", "não lidas")}</span> : null}
        </NavLink>
      ))}
    </nav>
  );
}
